import React, { Component } from 'react';
import { connect } from "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArchive } from '@fortawesome/free-solid-svg-icons'
import { COLORS } from '../styles/colors';
import { archiveWorkout } from "../store/actions/workouts";
import { archiveProgram } from "../store/actions/programs";
import withAuth from '../hocs/withAuth';
import { ConfirmJsMessage } from '../helpers.js'

class ArchiveButton extends Component {

  updateItemStatus(status) {
    const { updateWorkoutStatus, updateProgramStatus, item, type } = this.props;
    if (ConfirmJsMessage(`Are you sure you want to ${status ? 'archive' : 'unarchive'} the ${type}?`)) {
      const func = type === 'workout' ? updateWorkoutStatus : updateProgramStatus;
      func({
        _id: item._id,
        status: status
      }).then((response) => {
        window.location.reload();
      });
    }
  }

  render() {
    const { item } = this.props;
    if (!item) return null;
    const { isArchive } = item;
    return (
      <div>
      { isArchive ?
        <span
          className="link"
          onClick={() => {this.updateItemStatus(false)}}
          style={{ float: 'right', marginRight: 2 }}>
          <FontAwesomeIcon icon={faArchive} title={"UnArchive"}
            style={{ marginRight: 5, color: COLORS.orange }} />
        </span>
      : <span
          className="link"
          onClick={() => {this.updateItemStatus(true)}}
          style={{ float: 'right', marginRight: 2 }}>
          <FontAwesomeIcon icon={faArchive} title={"Archive"}
            style={{ marginRight: 5, color: COLORS.red }} />
        </span>
      }
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
    return {
      errors: state.errors
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
      updateWorkoutStatus: (data) => {
        return dispatch(archiveWorkout(data));
      },
      updateProgramStatus: (data) => {
        return dispatch(archiveProgram(data));
      }
    }
  }

export default connect(mapStateToProps, mapDispatchToProps)(withAuth(ArchiveButton));



// WEBPACK FOOTER //
// ./src/components/ArchiveButton.js